export default "<app-reset-password></app-reset-password>";